import {
  action,
  observable
} from 'mobx';
import {
  EMPTY_STRING,
  LOCAL_STORE_AUTH_TOKEN,
  LOCAL_STORE_AUTH_USER
} from '../../constants/constants';
import AuthenticationService from '../services/authentication.service';

export class AuthenticationStore {

  @observable username = EMPTY_STRING;

  @observable password = EMPTY_STRING;

  @observable error = null;

  @observable hasAuthenticationToken = this.checkAuthenticationToken();

  /**
   * Returns true authentication token exists in local store.
   * @return {bool} state - The state of token existance.
   * */
  @action checkAuthenticationToken = () => {
    if (localStorage.getItem(LOCAL_STORE_AUTH_TOKEN)
      && localStorage.getItem(LOCAL_STORE_AUTH_USER)) {
      return true;
    }
    return false;
  }

  /**
   * Sets username.
   * @param {string} username - The username to set.
   * */
  @action setUsername = (username) => {
    this.username = username;
  };

  /**
   * Sets password.
   * @param {string} password - The password to set.
   * */
  @action setPassword = (password) => {
    this.password = password;
  };

  /**
   * Sets error.
   * @param {string} message - The message to set.
   * */
  @action setError = (message) => {
    this.error = message;
  };

  /**
   * Sets authentication token existance flag.
   * @param {bool} state - The authentication Token boolean state.
   * */
  @action setHasAuthenticationToken = (state) => {
    this.hasAuthenticationToken = state;
  };

  /**
   * Does login.
   * */
  @action login = async () => {
    var spinnerThing = document.querySelector('#spinnerThing');
    var spinnerBackground = document.querySelector('.spinner-background');
    try {
      const response = await AuthenticationService.login(this.username, this.password);
      localStorage.setItem(LOCAL_STORE_AUTH_TOKEN, response.token);
      localStorage.setItem(LOCAL_STORE_AUTH_USER, JSON.stringify(response.user));
      this.setHasAuthenticationToken(true);
      spinnerThing.style.display = 'none';
      spinnerBackground.style.display = 'none';
      if (response) {
        this.error = response.error;
      }
    } catch (e) {
      this.clearAuthenticationLocalStore();
      this.setError(e.message);
      spinnerThing.style.display = 'none';
      spinnerBackground.style.display = 'none';
    }
  };

  /**
   * Removes authentication token from local store
   * */
  @action clearAuthenticationLocalStore = () => {
    localStorage.removeItem(LOCAL_STORE_AUTH_TOKEN);
    localStorage.removeItem(LOCAL_STORE_AUTH_USER);
    this.setHasAuthenticationToken(false);
  };
}

export default new AuthenticationStore();



// WEBPACK FOOTER //
// ./src/messages/stores/authentication.store.js